import { render, staticRenderFns } from "./IncidentRiskTypesFilters.vue?vue&type=template&id=434f698a"
import script from "./IncidentRiskTypesFilters.vue?vue&type=script&lang=js"
export * from "./IncidentRiskTypesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports